const currencyList = [
  {
    country: "AFGHANISTAN",
    currency: "Afghani",
    code: "AFN",
    numericCode: 971,
  },
  { country: "ALBANIA", currency: "Lek", code: "ALL", numericCode: 8 },
  {
    country: "ALGERIA",
    currency: "Algerian Dinar",
    code: "DZD",
    numericCode: 12,
  },
  { country: "ANDORRA", currency: "Euro", code: "EUR", numericCode: 978 },
  { country: "ANGOLA", currency: "Kwanza", code: "AOA", numericCode: 973 },
  {
    country: "ANGUILLA",
    currency: "East Caribbean Dollar",
    code: "XCD",
    numericCode: 951,
  },
  {
    country: "ARGENTINA",
    currency: "Argentine Peso",
    code: "ARS",
    numericCode: 32,
  },
  {
    country: "ARMENIA",
    currency: "Armenian Dram",
    code: "AMD",
    numericCode: 51,
  },
  {
    country: "ARUBA",
    currency: "Aruban Florin",
    code: "AWG",
    numericCode: 533,
  },
  {
    country: "AUSTRALIA",
    currency: "Australian Dollar",
    code: "AUD",
    numericCode: 36,
  },
  {
    country: "AZERBAIJAN",
    currency: "Azerbaijanian Manat",
    code: "AZN",
    numericCode: 944,
  },
  {
    country: "BAHAMAS (THE)",
    currency: "Bahamian Dollar",
    code: "BSD",
    numericCode: 44,
  },
  {
    country: "BAHRAIN",
    currency: "Bahraini Dinar",
    code: "BHD",
    numericCode: 48,
  },
  { country: "BANGLADESH", currency: "Taka", code: "BDT", numericCode: 50 },
  {
    country: "BARBADOS",
    currency: "Barbados Dollar",
    code: "BBD",
    numericCode: 52,
  },
  {
    country: "BELARUS",
    currency: "Belarussian Ruble",
    code: "BYN",
    numericCode: 933,
  },
  {
    country: "BELIZE",
    currency: "Belize Dollar",
    code: "BZD",
    numericCode: 84,
  },
  {
    country: "BENIN",
    currency: "CFA Franc BCEAO",
    code: "XOF",
    numericCode: 952,
  },
  {
    country: "BERMUDA",
    currency: "Bermudian Dollar",
    code: "BMD",
    numericCode: 60,
  },
  { country: "BHUTAN", currency: "Ngultrum", code: "BTN", numericCode: 64 },
  { country: "BOLIVIA", currency: "Boliviano", code: "BOB", numericCode: 68 },
  {
    country: "BOSNIA AND HERZEGOVINA",
    currency: "Convertible Mark",
    code: "BAM",
    numericCode: 977,
  },
  { country: "BOTSWANA", currency: "Pula", code: "BWP", numericCode: 72 },
  {
    country: "BOUVET ISLAND",
    currency: "Norwegian Krone",
    code: "NOK",
    numericCode: 578,
  },
  {
    country: "BRAZIL",
    currency: "Brazilian Real",
    code: "BRL",
    numericCode: 986,
  },
  {
    country: "BRUNEI",
    currency: "Brunei Dollar",
    code: "BND",
    numericCode: 96,
  },
  {
    country: "BULGARIA",
    currency: "Bulgarian Lev",
    code: "BGN",
    numericCode: 975,
  },
  {
    country: "BURUNDI",
    currency: "Burundi Franc",
    code: "BIF",
    numericCode: 108,
  },
  {
    country: "CABO VERDE",
    currency: "Cabo Verde Escudo",
    code: "CVE",
    numericCode: 132,
  },
  { country: "CAMBODIA", currency: "Riel", code: "KHR", numericCode: 116 },
  {
    country: "CANADA",
    currency: "Canadian Dollar",
    code: "CAD",
    numericCode: 124,
  },
  {
    country: "CAYMAN ISLANDS",
    currency: "Cayman Islands Dollar",
    code: "KYD",
    numericCode: 136,
  },
  {
    country: "CHILE",
    currency: "Unidad de Fomento",
    code: "CLF",
    numericCode: 990,
  },
  {
    country: "CHINA",
    currency: "Yuan Renminbi",
    code: "CNY",
    numericCode: 156,
  },
  {
    country: "COLOMBIA",
    currency: "Colombian Peso",
    code: "COP",
    numericCode: 170,
  },
  {
    country: "CONGO",
    currency: "CFA Franc BEAC",
    code: "XAF",
    numericCode: 950,
  },
  {
    country: "COSTA RICA",
    currency: "Costa Rican Colon",
    code: "CRC",
    numericCode: 188,
  },
  {
    country: "CUBA",
    currency: "Peso Convertible",
    code: "CUC",
    numericCode: 931,
  },
  {
    country: "CURAÇAO",
    currency: "Netherlands Antillean Guilder",
    code: "ANG",
    numericCode: 532,
  },
  {
    country: "CZECH REPUBLIC",
    currency: "Czech Koruna",
    code: "CZK",
    numericCode: 203,
  },
  {
    country: "DENMARK",
    currency: "Danish Krone",
    code: "DKK",
    numericCode: 208,
  },
  {
    country: "DJIBOUTI",
    currency: "Djibouti Franc",
    code: "DJF",
    numericCode: 262,
  },
  {
    country: "DOMINICAN REPUBLIC",
    currency: "Dominican Peso",
    code: "DOP",
    numericCode: 214,
  },
  {
    country: "EGYPT",
    currency: "Egyptian Pound",
    code: "EGP",
    numericCode: 818,
  },
  {
    country: "EL SALVADOR",
    currency: "El Salvador Colon",
    code: "SVC",
    numericCode: 222,
  },
  { country: "ERITREA", currency: "Nakfa", code: "ERN", numericCode: 232 },
  {
    country: "ETHIOPIA",
    currency: "Ethiopian Birr",
    code: "ETB",
    numericCode: 230,
  },
  {
    country: "FALKLAND ISLANDS",
    currency: "Falkland Islands Pound",
    code: "FKP",
    numericCode: 238,
  },
  { country: "FIJI", currency: "Fiji Dollar", code: "FJD", numericCode: 242 },
  { country: "GEORGIA", currency: "Lari", code: "GEL", numericCode: 981 },
  { country: "GHANA", currency: "Ghana Cedi", code: "GHS", numericCode: 936 },
  { country: "GUATEMALA", currency: "Quetzal", code: "GTQ", numericCode: 320 },
  {
    country: "GUINEA",
    currency: "Guinea Franc",
    code: "GNF",
    numericCode: 324,
  },
  {
    country: "GUYANA",
    currency: "Guyana Dollar",
    code: "GYD",
    numericCode: 328,
  },
  { country: "HAITI", currency: "Gourde", code: "HTG", numericCode: 332 },
  { country: "HONDURAS", currency: "Lempira", code: "HNL", numericCode: 340 },
  { country: "HUNGARY", currency: "Forint", code: "HUF", numericCode: 348 },
  {
    country: "ICELAND",
    currency: "Iceland Krona",
    code: "ISK",
    numericCode: 352,
  },
  { country: "INDIA", currency: "Indian Rupee", code: "INR", numericCode: 356 },
  { country: "INDONESIA", currency: "Rupiah", code: "IDR", numericCode: 360 },
  { country: "IRAN", currency: "Iranian Rial", code: "IRR", numericCode: 364 },
  { country: "IRAQ", currency: "Iraqi Dinar", code: "IQD", numericCode: 368 },
  {
    country: "ISRAEL",
    currency: "New Israeli Sheqel",
    code: "ILS",
    numericCode: 376,
  },
  {
    country: "JAMAICA",
    currency: "Jamaican Dollar",
    code: "JMD",
    numericCode: 388,
  },
  { country: "JAPAN", currency: "Yen", code: "JPY", numericCode: 392 },
  {
    country: "JORDAN",
    currency: "Jordanian Dinar",
    code: "JOD",
    numericCode: 400,
  },
  { country: "KAZAKHSTAN", currency: "Tenge", code: "KZT", numericCode: 398 },
  {
    country: "KENYA",
    currency: "Kenyan Shilling",
    code: "KES",
    numericCode: 404,
  },
  {
    country: "KUWAIT",
    currency: "Kuwaiti Dinar",
    code: "KWD",
    numericCode: 414,
  },
  { country: "KYRGYZSTAN", currency: "Som", code: "KGS", numericCode: 417 },
  { country: "LAO", currency: "Kip", code: "LAK", numericCode: 418 },
  {
    country: "LEBANON",
    currency: "Lebanese Pound",
    code: "LBP",
    numericCode: 422,
  },
  { country: "LESOTHO", currency: "Loti", code: "LSL", numericCode: 426 },
  {
    country: "LIBERIA",
    currency: "Liberian Dollar",
    code: "LRD",
    numericCode: 430,
  },
  { country: "LIBYA", currency: "Libyan Dinar", code: "LYD", numericCode: 434 },
  {
    country: "MADAGASCAR",
    currency: "Malagasy Ariary",
    code: "MGA",
    numericCode: 969,
  },
  { country: "MALAWI", currency: "Kwacha", code: "MWK", numericCode: 454 },
  {
    country: "MALAYSIA",
    currency: "Malaysian Ringgit",
    code: "MYR",
    numericCode: 458,
  },
  { country: "MALDIVES", currency: "Rufiyaa", code: "MVR", numericCode: 462 },
  { country: "MAURITANIA", currency: "Ouguiya", code: "MRU", numericCode: 929 },
  {
    country: "MAURITIUS",
    currency: "Mauritius Rupee",
    code: "MUR",
    numericCode: 480,
  },
  {
    country: "MEXICO",
    currency: "Mexican Peso",
    code: "MXN",
    numericCode: 484,
  },
  {
    country: "MOLDOVA",
    currency: "Moldovan Leu",
    code: "MDL",
    numericCode: 498,
  },
  { country: "MONGOLIA", currency: "Tugrik", code: "MNT", numericCode: 496 },
  {
    country: "MOROCCO",
    currency: "Moroccan Dirham",
    code: "MAD",
    numericCode: 504,
  },
  {
    country: "MOZAMBIQUE",
    currency: "Mozambique Metical",
    code: "MZN",
    numericCode: 943,
  },
  { country: "MYANMAR", currency: "Kyat", code: "MMK", numericCode: 104 },
  {
    country: "NAMIBIA",
    currency: "Namibia Dollar",
    code: "NAD",
    numericCode: 516,
  },
  {
    country: "NEPAL",
    currency: "Nepalese Rupee",
    code: "NPR",
    numericCode: 524,
  },
  {
    country: "NEW ZEALAND",
    currency: "New Zealand Dollar",
    code: "NZD",
    numericCode: 554,
  },
  {
    country: "NICARAGUA",
    currency: "Cordoba Oro",
    code: "NIO",
    numericCode: 558,
  },
  { country: "NIGERIA", currency: "Naira", code: "NGN", numericCode: 566 },
  { country: "OMAN", currency: "Rial Omani", code: "OMR", numericCode: 512 },
  {
    country: "PAKISTAN",
    currency: "Pakistan Rupee",
    code: "PKR",
    numericCode: 586,
  },
  { country: "PANAMA", currency: "Balboa", code: "PAB", numericCode: 590 },
  {
    country: "PAPUA NEW GUINEA",
    currency: "Kina",
    code: "PGK",
    numericCode: 598,
  },
  { country: "PARAGUAY", currency: "Guarani", code: "PYG", numericCode: 600 },
  { country: "PERU", currency: "Nuevo Sol", code: "PEN", numericCode: 604 },
  {
    country: "PHILIPPINES",
    currency: "Philippine Peso",
    code: "PHP",
    numericCode: 608,
  },
  { country: "POLAND", currency: "Zloty", code: "PLN", numericCode: 985 },
  { country: "QATAR", currency: "Qatari Rial", code: "QAR", numericCode: 634 },
  {
    country: "ROMANIA",
    currency: "Romanian Leu",
    code: "RON",
    numericCode: 946,
  },
  {
    country: "RUSSIAN FEDERATION",
    currency: "Russian Ruble",
    code: "RUB",
    numericCode: 643,
  },
  {
    country: "RWANDA",
    currency: "Rwanda Franc",
    code: "RWF",
    numericCode: 646,
  },
  {
    country: "SAUDI ARABIA",
    currency: "Saudi Riyal",
    code: "SAR",
    numericCode: 682,
  },
  {
    country: "SERBIA",
    currency: "Serbian Dinar",
    code: "RSD",
    numericCode: 941,
  },
  {
    country: "SEYCHELLES",
    currency: "Seychelles Rupee",
    code: "SCR",
    numericCode: 690,
  },
  { country: "SIERRA LEONE", currency: "Leone", code: "SLE", numericCode: 925 },
  {
    country: "SINGAPORE",
    currency: "Singapore Dollar",
    code: "SGD",
    numericCode: 702,
  },
  { country: "SOUTH AFRICA", currency: "Rand", code: "ZAR", numericCode: 710 },
  {
    country: "SRI LANKA",
    currency: "Sri Lanka Rupee",
    code: "LKR",
    numericCode: 144,
  },
  {
    country: "SUDAN",
    currency: "Sudanese Pound",
    code: "SDG",
    numericCode: 938,
  },
  {
    country: "SURINAME",
    currency: "Surinam Dollar",
    code: "SRD",
    numericCode: 968,
  },
  {
    country: "SWEDEN",
    currency: "Swedish Krona",
    code: "SEK",
    numericCode: 752,
  },
  {
    country: "SWITZERLAND",
    currency: "Swiss Franc",
    code: "CHF",
    numericCode: 756,
  },
  {
    country: "SYRIAN ARAB REPUBLIC",
    currency: "Syrian Pound",
    code: "SYP",
    numericCode: 760,
  },
  {
    country: "TAIWAN",
    currency: "New Taiwan Dollar",
    code: "TWD",
    numericCode: 901,
  },
  { country: "TAJIKISTAN", currency: "Somoni", code: "TJS", numericCode: 972 },
  {
    country: "TANZANIA",
    currency: "Tanzanian Shilling",
    code: "TZS",
    numericCode: 834,
  },
  { country: "THAILAND", currency: "Baht", code: "THB", numericCode: 764 },
  {
    country: "TUNISIA",
    currency: "Tunisian Dinar",
    code: "TND",
    numericCode: 788,
  },
  {
    country: "TURKEY",
    currency: "Turkish Lira",
    code: "TRY",
    numericCode: 949,
  },
  {
    country: "TURKMENISTAN",
    currency: "Turkmenistan New Manat",
    code: "TMT",
    numericCode: 934,
  },
  {
    country: "UGANDA",
    currency: "Uganda Shilling",
    code: "UGX",
    numericCode: 800,
  },
  { country: "UKRAINE", currency: "Hryvnia", code: "UAH", numericCode: 980 },
  {
    country: "UNITED ARAB EMIRATES",
    currency: "UAE Dirham",
    code: "AED",
    numericCode: 784,
  },
  {
    country: "UNITED KINGDOM",
    currency: "Pound Sterling",
    code: "GBP",
    numericCode: 826,
  },
  {
    country: "UNITED STATES",
    currency: "US Dollar",
    code: "USD",
    numericCode: 840,
  },
  {
    country: "URUGUAY",
    currency: "Peso Uruguayo",
    code: "UYU",
    numericCode: 858,
  },
  {
    country: "UZBEKISTAN",
    currency: "Uzbekistan Sum",
    code: "UZS",
    numericCode: 860,
  },
  { country: "VENEZUELA", currency: "Bolivar", code: "VED", numericCode: 926 },
  { country: "VIET NAM", currency: "Dong", code: "VND", numericCode: 704 },
  { country: "YEMEN", currency: "Yemeni Rial", code: "YER", numericCode: 886 },
  {
    country: "ZAMBIA",
    currency: "Zambian Kwacha",
    code: "ZMW",
    numericCode: 967,
  },
  {
    country: "ZIMBABWE",
    currency: "Zimbabwe Dollar",
    code: "ZWL",
    numericCode: 932,
  },
];

export const mappedCurrencyList = currencyList.map((item) => ({
  value: item.code,
  label: `${item.currency} (${item.code})`,
  group: "Currency",
}));

export const convertCurrency = (
  amount,
  fromCurrency,
  toCurrency,
  exchangeRates = 1
) => {
  if (fromCurrency === toCurrency) return amount;

  const rate = exchangeRates;
  return amount * rate;
};

export default currencyList;
